
import { Message } from 'element-ui';
import { post } from './api'
import router from 'vue-router'

export class Auth {
  loading: boolean = false
  isOtp: boolean = false
  otpCode: string = ''
  self = this
  goLogin(user: any, router: any) {
    this.loading = true
    post('/v1/config/login', user)
      .then(d => {
        // @ts-ignore
        sessionStorage.setItem('Apk-Jwt-Token', d['data']['token'])
        sessionStorage.setItem('username', user.account)
        Message({
          message: '登录成功',
          type: 'success',
          duration: 5 * 1000
        })
        this.loading = false
        router.push('/available-domain')
      })
      .catch(e => {
        this.loading = false
      })
  }
}
